export const taskInfoRowStyles = {
  backgroundColor: ({ palette }) => palette.background.secondary,
  borderRadius: 1,
};
